import { requireStoreFeature } from "$/lib/require-store-feature.ts"
import { achievementsSearchSchema } from "$/routes/(app)/_auth/prestationer/index"
import { STORE_FEATURE } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/prestationer/$mechanicId/")({
  validateSearch: achievementsSearchSchema,
  loader: async ({ context: { queryClient } }) => {
    await requireStoreFeature(queryClient, STORE_FEATURE.INSIGHTS)
    return {
      crumb: "alfred.pages.achievements.crumbs.mechanic",
    }
  },
})
